export const links = {
  HOME: { path: '/', tracking: {} },
  CONNECT_WITH_SEEK: {
    name: 'Connect with SEEK',
    path: '/connect-with-seek',
    tracking: 'connect-with-seek-link-clicked',
  },
  WHATS_POSSIBLE: {
    name: 'What’s possible?',
    activeTab: 'whats-possible',
    path: '/whats-possible',
    tracking: 'seek-job-posting-link-clicked',
  },
  CONNECTED_PARTERS: {
    name: 'Connected Partners',
    path: '/connected-partners',
    tracking: 'connected-partners-link-clicked',
  },
  RELEASE_NOTES: {
    name: 'Release notes',
    path: '/release-notes',
    tracking: 'release-notes-link-clicked',
  },
  LINK_YOUR_SOFTWARE: {
    name: 'Link your software',
    path: '/link-your-software',
    tracking: 'link-your-software-link-clicked',
  },
  DEVELOPER_SITE: {
    url: 'https://developer.seek.com',
    tracking: 'developer-site-link-clicked',
  },
  HOW_TO_INTEGRATE: {
    name: 'How to integrate',
    href: 'https://developer.seek.com/introduction',
    tracking: 'how-to-integrate-link-clicked',
  },
  INTEGRATION_REQUEST: {
    name: 'Integration request',
    path: '/integration-request',
    tracking: 'integration-request-link-clicked',
  },
  TERMS: {
    name: 'Terms of use',
    path: '/terms-of-use',
    tracking: 'terms-link-clicked',
  },
};
